// #region Imports
import React from 'react';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

import { SnackbarProvider } from 'notistack';

import AppRoutes from './AppRoutes';
import './assets/css/global.css';
import Footer from './components/Footer';
import Header from './components/Header';
import LoadingErrorMessage from './components/LoadingErrorMessage/LoadingErrorMessage';
import { PartnerProvider } from './context/PartnerContext';
import store from './store';
import history from './utils/history';

// #endregion

function App() {
  return (
    <Provider store={store}>
      <HistoryRouter history={history}>
        <PartnerProvider>
          <SnackbarProvider
            maxSnack={2}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <Header />
            <AppRoutes />
            <Footer />
            <LoadingErrorMessage />
          </SnackbarProvider>
        </PartnerProvider>
      </HistoryRouter>
    </Provider>
  );
}

export default App;
